import { useAsyncGql } from '#imports';
import { useI18n } from '#imports';

export const useLocalePaths = async () => {
  const { locales } = useI18n();
  const state = useState<Record<string, string[]>>('localePaths', () => ({}));

  for (const locale of locales.value) {
    const { data } = await useAsyncGql({
      operation: 'GetTranslatedSlugs',
      variables: { locale: locale.value as any },
    });
    if (data.value) {
      state.value[locale.value] = data.value.allPages.map((page) => {
        const slug = page._allSlugLocales?.find(
          (s) => s.locale === locale.value,
        );
        return slug?.value ?? '';
      });
    }
  }

  return state;
};
